import { motion, useInView } from "framer-motion"
import { Link, graphql, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import ImageOpt from "./ImageOpt"

import { Navigation } from "swiper"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"

const Testimonial = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])
  const testiData = useStaticQuery(graphql`
    query WpTestimonial {
      allWpTestimonial {
        nodes {
          title
          content
          featuredImage {
            node {
              altText
              mediaItemUrl
            }
          }
          terms {
            nodes {
              name
            }
          }
          testimonialContent {
            authorLocation
            authorName
            explore {
              target
              title
              url
            }
          }
        }
      }
    }
  `)

  const testiAllData = testiData.allWpTestimonial.nodes

  const handleNextClick = selector => {
    const swiper = document.querySelector(selector).swiper
    swiper.slideNext()
  }
  const handlePrevClick = selector => {
    const swiper = document.querySelector(selector).swiper
    swiper.slidePrev()
  }

  if (module.hideSection === "no") {
    return (
      <section
        className={`bg-white-100 ${
          module.extraClass ? ` ${module.extraClass}` : ""
        }`}
        id={module.extraId}
      >
        <motion.div
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`testimonial relative pt-60 lgscreen:pt-35${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
          >
            {testiAllData.length > 0 && (
              <motion.div variants={animFade}>
                <Swiper
                  spaceBetween={30}
                  loop={true}
                  slidesPerView={"1"}
                  speed={2000}
                  pagination={{
                    clickable: false,
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                    },
                    641: {
                      slidesPerView: 1,
                    },
                    1024: {
                      slidesPerView: 1,
                    },
                  }}
                  modules={[Navigation]}
                >
                  {testiAllData.map((item, i) => {
                    return (
                      <SwiperSlide key={i}>
                        <div className="flex flex-wrap">
                          <div className="lg:w-6/12 w-full">
                            {item?.featuredImage && (
                              <div className="img relative">
                                <ImageOpt
                                  imgData={item.featuredImage.node.mediaItemUrl}
                                  width={800}
                                  height={668}
                                  imgAlt={item.featuredImage.node.altText}
                                  imgLoad="lazy"
                                />
                              </div>
                            )}
                          </div>
                          <div className="lg:w-6/12 w-full bg-charcoal">
                            <div className="p-120 desktop2:px-0 desktop2:w-[482px] desktop2:mx-auto xlscreen:w-[450px] lgscreen:w-full lgscreen:p-30 h-full flex items-center justify-center">
                              <div className="title-white">
                                {item?.title && <h5>{item.title}</h5>}
                                {item?.testimonialContent?.authorLocation && (
                                  <div className="flex flex-wrap items-center gap-x-2 relative -left-2 mt-5">
                                    <img
                                      src="images/location-white.svg"
                                      width={12}
                                      height={12}
                                      loading="lazy"
                                      alt="Location"
                                    />
                                    <span className="text-white-100 font-ositalic text-13">
                                      {item.testimonialContent.authorLocation}
                                    </span>
                                  </div>
                                )}
                                {item?.content && (
                                  <h6 className="text-19 lgscreen:text-18 lgscreen:leading-26 font-ositalic leading-29 normal-case my-30">
                                    {parse(item.content.replace(/<\/?p>/g, ""))}
                                  </h6>
                                )}
                                {item?.testimonialContent?.authorName && (
                                  <span className="text-12 text-white-100 leading-22">
                                    {item.testimonialContent.authorName}
                                  </span>
                                )}
                                {item?.testimonialContent?.explore && (
                                  <div className="relative mt-30">
                                    <Link
                                      to={item.testimonialContent.explore.url}
                                      className="text-link white"
                                      target={
                                        item.testimonialContent.explore.title
                                      }
                                    >
                                      {item.testimonialContent.explore.title}
                                    </Link>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    )
                  })}
                </Swiper>
              </motion.div>
            )}
          </motion.div>
          <div className="swiper-arrow arrow-big flex gap-x-5">
            <button
              className="absolute left-30 lgscreen:left-20 top-50per lgscreen:top-[calc(50%_-_-20px)] mdscreen:top-[calc(50%_-_-10px)] smscreen:top-[calc(27%_-_20px)] xsscreen:top-[calc(28%_-_50px)] translate-y-minus_50 z-9 transition-all duration-300 outline-none"
              onClick={() => handlePrevClick(".testimonial .swiper")}
            >
              <img
                src="../images/slider-arrow.svg"
                width={42}
                height={42}
                loading="lazy"
                alt="Arrow"
              />
            </button>
            <button
              className="absolute right-30 lgscreen:right-20 top-50per lgscreen:top-[calc(50%_-_-20px)] mdscreen:top-[calc(50%_-_-10px)] smscreen:top-[calc(27%_-_20px)] xsscreen:top-[calc(28%_-_50px)] translate-y-minus_50 z-9 transition-all duration-300 outline-none"
              onClick={() => handleNextClick(".testimonial .swiper")}
            >
              <img
                src="../images/slider-arrow.svg"
                width={42}
                height={42}
                className="scale-x-[-1]"
                loading="lazy"
                alt="Arrow"
              />
            </button>
          </div>
        </motion.div>
      </section>
    )
  }
  return null
}

export default Testimonial
export const PageTestimonialFragment = graphql`
  fragment PageTestimonialFragment on WpPage_Pagecontent_PageContent_Testimonial {
    extraId
    extraClass
    hideSection
  }
`
